import { Controller } from '@hotwired/stimulus';
import { Collapse } from 'bootstrap';

export default class SecondaryParamsController extends Controller {
  static targets = ['paramBody'];

  connect() {
    this.element.addEventListener('show.bs.collapse', (e) => this.onShow(e));
  }

  disconnect() {
    this.element.removeEventListener('show.bs.collapse', (e) => this.onShow(e));
  }

  onShow(event) {
    this.paramBodyTargets.forEach((body) => {
      if (body !== event.target && body.classList.contains('show')) {
        const bsCollapse = Collapse.getInstance(body);
        if (bsCollapse) {
          bsCollapse.hide();
        }
      }
    });
  }
}
